import React, { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import useInterval from 'use-interval'

const ImageSlideShow = ({ title, subtitle, components }) => {
  // const tabs = components.map(comp => comp.title)
  // Declare a new state variable, which we'll call "count"
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  // start slideshow
  // turn of auto scroll
  // useInterval(() => {
  //   // Your custom logic here
  //   setActiveTabIndex((activeTabIndex + 1) % components.length)
  // }, 3500)
  const subtitleFrags = subtitle.subtitle.split('\n')
  let backgroundColor = subtitleFrags.length > 1 ? subtitleFrags[1] : '#f6f6f6'

  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.descriptionBox}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && (
            <div className={styles.subtitle}>{subtitleFrags[0]}</div>
          )}
        </div>
        <div className={styles.slideShowBox}>
          <div className={styles.tabContainer}>
            {components.map((tab, index) => (
              <div
                key={index}
                className={`${styles.tab} ${
                  index === activeTabIndex ? styles.active : ''
                }`}
                onClick={() => {
                  setActiveTabIndex(index)
                }}
              >
                <div>{tab.title}</div>
              </div>
            ))}
          </div>
          <div
            className={styles.slideshowImageContainer}
            style={{ backgroundColor: backgroundColor }}
          >
            <GatsbyImage
              image={components[activeTabIndex].image.gatsbyImageData}
              className={styles.slideShowImage}
              alt={components[activeTabIndex].image?.description}
              style={{ display: 'block' }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageSlideShow
